import styled from '@emotion/styled'

export const SelectCellWrapper = styled.div`
  display: flex;
  align-items: center;
`
